import {useStores} from "~/stores";

/**
 * The taxonomy to show: the profile's hard-coded one when set, otherwise the databag's own,
 * matching how the current builder picks it. Call from an `observer` component.
 */
export function useActiveTaxonomyId(): number | null {
    const {p, bagStore} = useStores();
    return p.p.hardcodeTaxonomyId ?? bagStore.bag?.taxonomy ?? null;
}
